import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { MenuService } from './../services/menu.service';
import { CommonAuthenticationService } from './../services/common-authentication.service';
import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-parent',
  templateUrl: './parent.component.html',
  styleUrls: ['./parent.component.scss']
})
export class ParentComponent implements OnInit {
  pinmenuBar: boolean;
  @ViewChild('content') content;
  constructor(
    private _commonAuthService: CommonAuthenticationService,
    private _menuService: MenuService,
    private _router: Router,
    private renderer: Renderer2,
    private _commonDataSharedService: CommonDataSharedService) { }

  ngOnInit() {
    document.addEventListener('click', this.offClickHandler.bind(this));
    this._commonDataSharedService.content.next(this.content);
    this.updateMenu();

  }

  updateMenu() {
    const inputJson = {
      role: this._commonAuthService.getRoleName()
    };
    this._menuService.getMenuData(inputJson, 'parent');
  }

  offClickHandler(event: any) {
    if (this._router.url.split('/')[1] === 'parent' && !document.querySelector('.parentMenu').contains(event.target) && !document.querySelector('.parentSideMenu').contains(event.target)) {
      this._commonDataSharedService.collapseMenu.next();
      this.pinmenuBar = JSON.parse(localStorage.getItem('toggleMenu'));
      if (this.pinmenuBar) {
        this.renderer.addClass(document.body, 'menu-open');
      }
      else {
        this.renderer.removeClass(document.body, 'menu-open');
      }
    }
  }

}
